


// Generated from io.spcfy.iv3.authentication.override.OverrideLicenseTier

export type OverrideLicenseTierKey =
  "BASE" |
  "INSIGHT" |
  "BETA";


export interface OverrideLicenseTierDTO {
  key: OverrideLicenseTierKey;    
}


export const OverrideLicenseTiers: Record<OverrideLicenseTierKey, OverrideLicenseTierDTO> = {
  BASE: { key: "BASE",  },
  INSIGHT: { key: "INSIGHT",  },
  BETA: { key: "BETA",  }
};
